import React, { Component } from "react";
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  withStyles,
} from "@material-ui/core";
import styles from "./DealerShipDetails.module.scss";
import crStyles from "../../customerReservation/crStyles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Button from "@material-ui/core/Button";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import Grid from "@material-ui/core/Grid";
import Clear from "@material-ui/icons/Clear";
import CheckIcon from "@material-ui/icons/Check";
import EditIcon from "../../../shared/Edit/EditIcon";
import { withTranslation } from "react-i18next";
import DealerEmployeeTable from "./DealerEmployeeTable";
import HasPermissionTo from "../../../common/HasPermissionTo";
import DealerDetailsClient from "../../../shared/clients/DealerDetailsClient";

const StyledExpansionPanelSummary = withStyles({
  content: {
    margin: 0,
    "&$expanded": {
      margin: 0,
    },
  },
  expanded: {
    margin: 0,
  },
})(ExpansionPanelSummary);

class DealerContactInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expand: true,
      editMode: false,
      currentEmailText: this.props.dealers.emailAddress,
      currentPhoneText: this.props.dealers.phoneNumber,
      emailText: this.props.dealers.emailAddress,
      phoneText: this.props.dealers.phoneNumber,
    };
    this.dealer = this.props.dealers;
  }
  componentDidMount() {}
  flipIcon() {
    const current = this.state.expand;
    this.setState({ expand: !current });
  }

  cancelEdit = () => {
    this.setState({
      editMode: false,
      emailText: this.state.currentEmailText,
      phoneText: this.state.currentPhoneText,
    });
  };

  updateEmailAndPhone = (completeDealerId) => {
    const emailIdValue = document.getElementById(
      "emailInput_" + completeDealerId
    ).value;

    DealerDetailsClient.updateDealerEmailAddress(
      this.props.user,
      completeDealerId,
      emailIdValue
    )
      .then(() => {
        this.setState({
          emailText: emailIdValue,
          currentEmailText: emailIdValue,
        });
      })
      .then(() => {
        this.updatePhone(completeDealerId, emailIdValue);
      })
      .catch(() => {});
  };

  updatePhone = (completeDealerId, emailIdValue) => {
    const phoneNumValue = document.getElementById(
      "phoneInput_" + completeDealerId
    ).value;
    DealerDetailsClient.updateDealerPhoneNumber(
      this.props.user,
      completeDealerId,
      phoneNumValue
    )
      .then((dealer) => {
        this.setState({
          phoneText: phoneNumValue,
          currentPhoneText: phoneNumValue,
          editMode: false,
        });
        this.props.updateDealerPhoneAndEmail(
          dealer,
          emailIdValue,
          phoneNumValue
        );
      })
      .catch(() => {});
  };

  editDealershipInfo = () => {
    this.setState({ editMode: true });
  };

  emailOnChange = (event) => {
    this.setState({ emailText: event.target.value });
  };

  phoneOnChange = (event) => {
    this.setState({ phoneText: event.target.value });
  };

  render() {
    const fromNscDealerSearch =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "dealerContactInfoSubmit"
      ) && this.props.fromNscDealerSearch;
    return (
      <div className={styles.divPadding}>
        <ExpansionPanel
          classes={{ root: styles.expPanelNoBoxShadow }}
          style={{ marginBottom: "10px" }}
          defaultExpanded={true}
          onChange={() => this.flipIcon()}
        >
          <StyledExpansionPanelSummary
            style={crStyles.headerBarNeutral}
            id="exp"
          >
            <div className={styles.headerBar}>
              <div className={styles.boldHeader}>
                {this.dealer.name}
                <span>({this.dealer.regionalId})</span>
              </div>
              {this.state.expand ? (
                <ExpandLessIcon id="less" />
              ) : (
                <ExpandMoreIcon id="more" />
              )}
            </div>
            <br />
          </StyledExpansionPanelSummary>
          <div className={styles.bottomBorder}></div>
          <div className={styles.businessDetailsContainer}>
            <div className={styles.sectionHeaderDealership}>
              {this.props.t("DealerShipDetails.dealershipHeader")}
            </div>
            <div className={styles.subHeader}>
              <span
                id="businessDetails"
                className={styles.businessDetailsInputGridModel}
              >
                {this.props.t("DealerShipDetails.businessDetails")}
              </span>
            </div>
            <ValidatorForm
              style={{ width: "100%" }}
              onSubmit={() =>
                this.updateEmailAndPhone(this.dealer.completeDealerId)
              }
            >
              <Grid container>
                <Grid item md={3} className={styles.divAddress}>
                  {this.props.user.market.toUpperCase() === "DEU" ? (
                    <>
                      <span>{this.dealer.address.street} </span>
                      <span>
                        {this.dealer.address.postalCode}&nbsp;
                        {this.dealer.address.city}
                      </span>
                      <span> {this.dealer.address.country}</span>
                    </>
                  ) : (
                    <>
                      <span>{this.dealer.address.street} </span>
                      <span> {this.dealer.address.city}</span>
                      <span>
                        {" "}
                        {this.dealer.address.country},
                        {this.dealer.address.postalCode}
                      </span>
                    </>
                  )}
                </Grid>

                <>
                  <Grid item md={3} className={styles.divEmail}>
                    {this.state.editMode ? (
                      <TextValidator
                        value={this.state.emailText}
                        onChange={this.emailOnChange}
                        variant="outlined"
                        style={{ width: "70%" }}
                        name={"emailInput_" + this.dealer.completeDealerId}
                        id={"emailInput_" + this.dealer.completeDealerId}
                        validators={["required", "isEmail"]}
                        errorMessages={[
                          this.props.t("Error.requiredField"),
                          this.props.t("Error.invalidInput"),
                        ]}
                      />
                    ) : (
                      <div>
                        {this.state.emailText ? (
                          <span className={styles.emailText}>
                            {this.state.emailText}
                          </span>
                        ) : (
                          this.props.t("DealerShipDetails.emailAddress")
                        )}
                      </div>
                    )}
                  </Grid>
                  <Grid item md={2} className={`${styles.divPhone}`}>
                    {this.state.editMode ? (
                      <TextValidator
                        variant="outlined"
                        style={{ width: "60%" }}
                        onChange={this.phoneOnChange}
                        value={this.state.phoneText}
                        name={"phoneInput_" + this.dealer.completeDealerId}
                        id={"phoneInput_" + this.dealer.completeDealerId}
                        validators={["required"]}
                        errorMessages={[this.props.t("Error.requiredField")]}
                      />
                    ) : (
                      <div>
                        {this.state.phoneText ? (
                          <span className={styles.phoneText}>
                            {this.state.phoneText}
                          </span>
                        ) : (
                          this.props.t("DealerShipDetails.phoneNumber")
                        )}
                      </div>
                    )}
                  </Grid>
                  <Grid item md={3} className={styles.divEmail}>
                    {this.state.editMode ? (
                      <TextValidator
                        value={this.state.emailText}
                        onChange={this.emailOnChange}
                        variant="outlined"
                        style={{ width: "70%" }}
                        name={"emailInput_" + this.dealer.completeDealerId}
                        id={"emailInput_" + this.dealer.completeDealerId}
                        validators={["isEmail"]}
                        errorMessages={[this.props.t("Error.invalidInput")]}
                      />
                    ) : (
                      <div>
                        {this.state.emailText ? (
                          <span
                            className={styles.emailText}
                            data-testid="email"
                          >
                            {this.state.emailText}
                          </span>
                        ) : (
                          this.props.t("DealerShipDetails.emailAddress")
                        )}
                      </div>
                    )}
                  </Grid>
                  ) : (<Grid item md={3}></Grid>
                  )}
                  <Grid
                    item
                    md={1}
                    className={
                      this.showAddress
                        ? styles.contactEditDiv
                        : styles.contactEditDivNoAddress
                    }
                  >
                    {this.state.editMode ? (
                      <>
                        <Button
                          id={"confirmInfo_" + this.dealer.regionalId}
                          type="submit"
                          disabled={fromNscDealerSearch}
                        >
                          <CheckIcon />
                        </Button>
                        <Button
                          id={"cancelInfo_" + this.dealer.regionalId}
                          onClick={this.cancelEdit}
                        >
                          <Clear />
                        </Button>
                      </>
                    ) : (
                      <HasPermissionTo
                        perform={["dealershipDetails:write"]}
                        permissions={
                          this.props.user.permissions.rolePermissions
                        }
                        condition={
                          !this.props.isMainViewingSDLR(this.props.dealers)
                        }
                        render={() => (
                          <Button
                            id={`Edit_${this.dealer.regionalId}`}
                            onClick={this.editDealershipInfo}
                          >
                            <EditIcon />
                          </Button>
                        )}
                      />
                    )}
                  </Grid>
                </>
              </Grid>
            </ValidatorForm>
          </div>
          <DealerEmployeeTable {...this.props} />
        </ExpansionPanel>
      </div>
    );
  }
}

export default withTranslation("emp")(DealerContactInfo);
